/** 숫자 입력값에서 콤마를 제거하고 파싱 */
export function parseNumberInput(raw?: string | number | null): number | null {
  if (raw == null || raw === '') return null;
  if (typeof raw === 'number') return Number.isFinite(raw) ? raw : null;
  const cleaned = String(raw).trim().replace(/,/g, '');
  if (!cleaned) return null;
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : null;
}

/** 입력 중 천 단위 콤마 표시 (소수 허용) */
export function formatNumberInput(raw: string): string {
  const cleaned = raw.replace(/,/g, '').replace(/[^\d.]/g, '');
  if (!cleaned) return '';
  const dot = cleaned.indexOf('.');
  const intRaw = dot >= 0 ? cleaned.slice(0, dot) : cleaned;
  const fracRaw = dot >= 0 ? cleaned.slice(dot + 1).replace(/\./g, '') : null;
  const intPart = intRaw.replace(/^0+(?=\d)/, '') || (fracRaw != null ? '0' : intRaw);
  const withComma = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return fracRaw != null ? `${withComma}.${fracRaw}` : withComma;
}

/** 저장된 숫자를 입력/표시용으로 */
export function formatNumberDisplay(value?: number | string | null): string {
  if (value == null || value === '') return '';
  const n = typeof value === 'number' ? value : parseNumberInput(String(value));
  if (n == null) return '';
  return formatNumberInput(String(n));
}
